import React from 'react';
import { Modal, P, Gap } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';

interface Props {
  heading?: string;
  isOpen: boolean;
  onOkButtonClicked: () => void;
  onCancelButtonClicked: () => void;
  okButtonLabel?: string;
  cancelButtonLabel?: string;
  children?: React.ReactNode;
}

export function UnsavedChangesModal(props: Props) {
  const { t } = useTranslation();
  return (
    <Modal
      heading={props.heading || t('common.unsavedChangesModal.heading')}
      isOpen={props.isOpen}
      variation="clean"
      okButtonLabel={props.okButtonLabel ?? t('common.confirm')}
      onOkButtonClicked={props.onOkButtonClicked}
      cancelButtonLabel={props.cancelButtonLabel ?? t('common.cancel')}
      onCancelButtonClicked={props.onCancelButtonClicked}
      onCloseButtonClicked={props.onCancelButtonClicked}
    >
      {props.children ? (
        props.children
      ) : (
        <>
          <P>{t('common.unsavedChangesModal.text')}</P>
          <Gap top={30} />
        </>
      )}
    </Modal>
  );
}
